import { useEffect, useState } from "react";
import { Loader2, Check } from "lucide-react";

// Pokazuje rzeczywiste etapy pracy modelu. NIE opóźnia żądania — ostatni etap trwa,
// dopóki odpowiedź nie wróci (active=false). Bez sztucznych „gotowe" przed czasem.
export function GenerationStatus({ stages, active, className = "" }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (!active) return;
    setIdx(0);
    // Przechodzimy przez etapy w kolejności realnego potoku; zatrzymujemy się na ostatnim.
    const t = setInterval(() => {
      setIdx((i) => (i < stages.length - 1 ? i + 1 : i));
    }, 3500);
    return () => clearInterval(t);
  }, [active, stages.length]);

  if (!active) return null;
  return (
    <div className={`space-y-2 ${className}`} data-testid="generation-status">
      {stages.map((s, i) => (
        <div key={i} className={`flex items-center gap-2.5 text-[13.5px] transition-opacity ${i <= idx ? "opacity-100" : "opacity-35"}`}>
          {i < idx ? (
            <Check size={15} className="text-brand-accent" />
          ) : i === idx ? (
            <Loader2 size={15} className="animate-spin text-brand-accent" />
          ) : (
            <span className="h-[15px] w-[15px] rounded-full border border-brand-line" />
          )}
          <span className={i <= idx ? "text-brand-text" : "text-brand-muted"}>{s}</span>
        </div>
      ))}
    </div>
  );
}
